import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { catchError, map, of, switchMap, zip } from 'rxjs';
import { ApiParams } from './api-params';
import { Resource } from './resource';
import { MOCK_APPLICATION_ACCESS_LIST, MOCK_PERMISSION_LIST, USE_MOCK_DATA_ON_ERROR } from './mock-data';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@content-platform/web-angular-shared-util-logging";
import * as i3 from "./api-params";
export class UserPermissionListResource extends Resource {
    constructor(http, logger, apiParams) {
        super(http, logger.instance('UserPermissionListResource'));
        this.apiParams = apiParams;
    }
    getUrl() {
        return '';
    }
    get(uuid) {
        return zip(this.getUserApps(uuid), this.getUserPermissions(uuid)).pipe(switchMap((data) => {
            const permissions = data[1];
            const applications = data[0];
            return of({
                uuid,
                applications,
                permissions
            }).pipe(switchMap((userPermissionList) => of(userPermissionList)));
        }));
    }
    get entityName() {
        return 'User Permission List';
    }
    getUserApps(uuid) {
        return this.http
            .get(this.apiParams.getUrl('userApplications', { uuid: uuid }), {
            headers: this.getHeaders(),
        })
            .pipe(catchError((error) => USE_MOCK_DATA_ON_ERROR
            ? of(MOCK_APPLICATION_ACCESS_LIST)
            : this.handleError(`Retrieving User Apps Failed`, error)));
    }
    getUserPermissions(uuid) {
        return this.http
            .get(this.apiParams.getUrl('userPermissions', { uuid: uuid }), {
            headers: this.getHeaders(),
        })
            .pipe(map((permissionsList) => {
            if (permissionsList.length > 0 &&
                permissionsList[0].permissions) {
                const permissions = [].concat(...permissionsList.map((list) => list.permissions));
                return permissions;
            }
            return permissionsList;
        }), catchError((error) => USE_MOCK_DATA_ON_ERROR
            ? of(MOCK_PERMISSION_LIST)
            : this.handleError(`Retrieving User Permissions Failed`, error)));
    }
    static { this.ɵfac = function UserPermissionListResource_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserPermissionListResource)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoggerService), i0.ɵɵinject(i3.ApiParams)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserPermissionListResource, factory: UserPermissionListResource.ɵfac }); }
}
//# sourceMappingURL=user-permission-list-resource.js.map